import { Resources } from '@/services/shiftkeyAPI/resources/Resources';
import BaseResource from '@/services/shiftkeyAPI/resources/BaseResource';

export default class InitialAppUser extends BaseResource {
  get(params) {
    return this.performGet(Resources.InitialAppUser, params);
  }
}
